import React, { Component } from 'react';
import { connect } from 'react-redux';
import { APIService } from '../../../../../Config/actions/apiAction';
import swal from 'sweetalert';
import { Fragment } from 'react';

class PhonepePackageFailurePage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            token: '',
            data: '',
            newPageUrl: ''
        }
    }

    route = (url) => {
        sessionStorage.setItem('homeScroll', window.pageYOffset);
        this.props.history.push(url)
    }

    showToast = (type, message) => {
        swal({
            text: ' ',
            title: message,
            icon: type,
            timer: 2000,
            buttons: false,
        })
    }

    componentDidMount() {
        this.setState({
            token: this.props.match.params.token
        }, () => {
            let fd = new FormData();
            fd.append('txn_id', this.state.token);
            this.props.dispatch(APIService('POST', '/home/check-transaction', fd)).then((data) => {
                if (data && data.data.status === 'success') {
                    this.setState({
                        data: data.data.data,
                        newPageUrl: data.data.data.back_url
                    })
                }
                else if (data && data.data.auth_failed === '1') {

                }
                else if (data && data.data.status === 'error') { this.route('/not-found') }
            }).catch((e) => {
                // console.log(e)
            })
        })
    }

    render() {
        return (
            <Fragment>
                <section className="page_section paySuccess_page" >
                    <div className="container">
                        <div className="row">
                            <div className="col-12 text-center">
                                <h1 className="mb-5 mt-5"><span className="orange_text text-capitalize">
                                    Hello {this.state.data.user},</span> <br/>failed to buy the package <br/>{this.state.data.product_name}! <br/>Please try again! </h1>
                                <button className="btn btn-sm orange_btn" onClick={() => window.open(this.state.newPageUrl, "_self")}> Back </button>
                            </div>
                        </div>
                    </div>
                </section>
            </Fragment>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        loginUser: () => {
            dispatch({
                type: 'loginUser'
            });
        },
        logoutUser: () => {
            dispatch({
                type: 'logoutUser'
            });
        },
        dispatch
    }
}

export default connect(null, mapDispatchToProps)(PhonepePackageFailurePage);